<template>
	<Modal
		v-if="visible"
		:allow-close="false"
		@modal:close="handleClose()"
	>
		<template #body>
			<div class="won-delete-red text-2xl font-semibold">{{ title }}</div>
			<div class="won-blue mt-2.5 text-sm">{{ subtitle }}</div>
		</template>
		<template #actions>
			<div class="flex w-full items-center justify-end">
				<won-button
					ghost
					:is-disabled="loading"
					class="confirm-delete-btn relative mr-6 w-28 hover:border-won-red hover:bg-won-red hover:text-white"
					@click="handleDelete"
				>
					<div
						v-if="loading"
						class="absolute inset-y-0 left-0 ml-3.5 flex items-center"
					>
						<svg
							class="won-color-nav-gray absolute mr-3 -ml-1 size-4 animate-spin"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
						>
							<circle
								class="opacity-25"
								cx="12"
								cy="12"
								r="10"
								stroke="currentColor"
								stroke-width="4"
							/>
							<path
								class="opacity-75"
								fill="currentColor"
								d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
							/>
						</svg>
					</div>
					Delete
				</won-button>
				<won-button
					class="w-28"
					@click="handleClose"
				>
					Cancel
				</won-button>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { onMounted, toRefs } from 'vue';
import Modal from '../components/modal.vue';
import WonButton from '../components/won-button.vue';


const props = defineProps({
	visible: {
		type: Boolean,
		default: false,
	},
	title: {
		type: String,
		default: '',
	},
	subtitle: {
		type: String,
		default: '',
	},
	loading: {
		type: Boolean,
		default: false,
	},
});

const { visible } = toRefs(props);
const emit = defineEmits(['delete-modal:close', 'delete-modal:confirm']);

onMounted(() => {
	document.onkeydown = function(e) {
		if (e.key === 'Escape' && visible.value) {
			handleClose();
		}
	};
});

const handleClose = () => {
	emit('delete-modal:close');
};

const handleDelete = () => {
	emit('delete-modal:confirm');
};
</script>
